import { Injectable, NgModule } from '@angular/core';
import { CommonModule, formatDate } from '@angular/common';
import { TimeTrackerCalendarCreateDialogComponent } from './time-tracker-calendar-create-dialog.component';
import { MaterialModule } from '@app/material.module';
import { TimeInputModule } from '../time-input/time-input.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomPipesModule } from '@app/_pipes/custom-pipes.module';
import { DateFnsModule } from 'ngx-date-fns';
import { CalendarDateFormatter, CalendarModule, DateAdapter, DateFormatterParams } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { MwlDayViewSchedulerModule } from '../mwl-day-view-scheduler/mwl-day-view-scheduler.module';
import { TaskPickerDialogModule } from '@app/components/task-picker-dialog/task-picker-dialog.module';
import { DisableControlModule } from '@app/directives/disable-control/disable-control.module';
import { UserAvatarModule } from '../user-avatar/user-avatar.module';
import { UserSinglePickerDialogModule } from '@app/components/user-single-picker-dialog/user-single-picker-dialog.module';
import { DurationInputControlModule } from '@app/components/duration-input-control/duration-input-control.module';

@Injectable()
class CustomDateFormatter extends CalendarDateFormatter {
  public dayViewHour({ date, locale }: DateFormatterParams): string {
    return formatDate(date, 'EEE', locale); // use short week days
  }
}
@NgModule({
  declarations: [TimeTrackerCalendarCreateDialogComponent],
  imports: [
    CommonModule,
    MaterialModule,
    CustomPipesModule,
    FlexLayoutModule,
    TimeInputModule,
    DurationInputControlModule,
    FormsModule,
    ReactiveFormsModule,
    DateFnsModule,
    TranslateModule,
    TaskPickerDialogModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    UserAvatarModule,
    UserSinglePickerDialogModule,
    DisableControlModule,
  ],
  exports: [TimeTrackerCalendarCreateDialogComponent],
})
export class TimeTrackerCalendarCreateDialogModule {}
